import QRCode from 'qrcode'
import React from 'react'
import { useSelector } from 'react-redux'

import { Modal } from 'components/Modal'
import { qrcodeEventEmitter, qrcodeKeys } from 'helpers/events'
import { isEmpty } from 'helpers/lodash'
import {
    classNotification,
    CLASS_NOTIFICATION_TYPES,
} from 'helpers/notification'
import { sendAppLinkToWhatsapp } from 'services/apis/app'
import { _qrcodeData } from 'store/selectors/User'

import {
    Container,
    QRCodeComponentContainer,
    StepInfo,
    LinkInfo,
    Title,
    WhatsappLink,
    Information,
    Description,
    LinkInfoMessage,
} from './styles'

const styles = {
    modal: {
        overflow: 'hidden',
        padding: 0,
        maxWidth: 330,
        maxHeight: 430,
    },
    closeButton: {
        width: 20,
        height: 28,
        top: 16,
        right: 28,
    },
}

const QRCodeComponent = ({ qrcodeData }) => {
    React.useEffect(() => {
        if (typeof qrcodeData === 'object' && !isEmpty(qrcodeData)) {
            QRCode.toCanvas(
                document.getElementById('qrcode-canvas'),
                JSON.stringify(qrcodeData),
                function(error) {
                    if (error) console.error(error)
                    console.log('success!')
                }
            )
        }
    }, [])

    return <canvas id="qrcode-canvas"></canvas>
}

const LoginQRCode = () => {
    const [isModalOpen, setIsModalOpen] = React.useState(false)

    const qrcodeData = useSelector(_qrcodeData)

    React.useEffect(() => {
        const openModal = () => {
            setIsModalOpen(true)
        }

        qrcodeEventEmitter.addListener(qrcodeKeys.SHOW_QR_CODE, openModal)

        return () => {
            qrcodeEventEmitter.removeListener(
                qrcodeKeys.SHOW_QR_CODE,
                openModal
            )
        }
    }, [])

    const onCloseModal = () => {
        setIsModalOpen(false)
    }

    const onSendAppLinkClick = async () => {
        try {
            const response = await sendAppLinkToWhatsapp()
            if (response.data.success) {
                classNotification({
                    type: CLASS_NOTIFICATION_TYPES.success,
                    data: { msg: 'App link sent. Check your phone!' },
                })
            }
        } catch (error) {
            console.log('error in sending app link ', error)
            classNotification({
                type: CLASS_NOTIFICATION_TYPES.error,
                data: { msg: 'Something Went Wrong!' },
            })
        }
    }

    return (
        <Modal
            isModalOpen={isModalOpen}
            onCloseModal={onCloseModal}
            styles={styles}
            showCloseIcon
        >
            <Title>Upload image</Title>
            <Container>
                <Information>
                    <Description>
                        <StepInfo>
                            Scan this code from your Oh app on your phone to
                            upload photos
                        </StepInfo>
                    </Description>
                    {qrcodeData ? (
                        <QRCodeComponentContainer>
                            <QRCodeComponent qrcodeData={qrcodeData} />
                        </QRCodeComponentContainer>
                    ) : null}

                    <LinkInfo>
                        <LinkInfoMessage>
                            In case you don’t have the app downloaded,{' '}
                            <WhatsappLink onClick={onSendAppLinkClick}>
                                send app link to whatsapp
                            </WhatsappLink>
                        </LinkInfoMessage>
                    </LinkInfo>
                </Information>
            </Container>
        </Modal>
    )
}

export { LoginQRCode }
